import { Markdown } from "@jurisui/react/primitives/markdown";

export function MarkdownBlock({ children, className = "" }: { children: string; className?: string }) {
  return <Markdown className={`live-markdown ${className}`.trim()}>{children}</Markdown>;
}
